import { render, staticRenderFns } from "./addOrEditMerchant.vue?vue&type=template&id=0999c42c"
import script from "./addOrEditMerchant.vue?vue&type=script&lang=js"
export * from "./addOrEditMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports